import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import type { Volume } from '../data/volumes';
type VolumeCardProps = {
  volume: Volume;
};
export function VolumeCard({
  volume
}: VolumeCardProps) {
  return <article className="overflow-hidden rounded-3xl bg-white shadow-card" data-id="element-265" data-mp="125saj5fcaaj8">
      <header className="px-6 py-6 text-white sm:px-8" style={{
      backgroundColor: volume.accent
    }} data-id="element-266" data-mp="y3ne5yxiazsw">
        <p className="text-sm font-extrabold uppercase tracking-[0.18em] text-white/85" data-id="element-267" data-mp="1utxs5jb3jjeu">Volume {volume.numeral}</p>
        <h3 className="mt-1.5 font-serif text-2xl font-bold leading-tight sm:text-3xl" data-id="element-268" data-mp="1pvcrjirxmxpv">{volume.title}</h3>
        <p className="mt-1.5 text-[16px] font-semibold text-white/90" data-id="element-269" data-mp="1l2a843gvd4ne">{volume.subtitle}</p>
      </header>

      <div className="px-6 py-7 sm:px-8" data-id="element-270" data-mp="1h186xh3e6iis">
        <p className="text-[17px] leading-relaxed text-muted" data-id="element-271" data-mp="2djvztyazfahy">{volume.intro}</p>

        <p className="mt-6 font-bold text-ink" data-id="element-272" data-mp="2dm0d36urtluw">Inside, you'll find:</p>
        <ul className="mt-3 grid gap-x-8 gap-y-3 md:grid-cols-2" data-id="element-273" data-mp="28se01dkp3fyk">
          {volume.inside.map(item => <li key={item} className="flex gap-3" data-id="element-274" data-mp="37ciqgdgq00ce">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-white" style={{
            backgroundColor: volume.accent
          }} data-id="element-275" data-mp="3catycingg0rz">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-276" data-mp="32ksa9qv3qid2" />
              </span>
              <span className="text-[16px] leading-relaxed text-ink" data-id="element-277" data-mp="2ol9fdzrax3ip">{item}</span>
            </li>)}
        </ul>

        <div className="mt-7 flex gap-3 rounded-2xl bg-canvas p-5" data-id="element-278" data-mp="2tldq195j3410">
          <TargetIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
          color: volume.accent
        }} aria-hidden="true" data-id="element-279" data-mp="2env3mdgbp2wq" />
          <p className="text-[16px] leading-relaxed text-ink" data-id="element-280" data-mp="2jnhdccwy010s">
            <strong data-id="element-281" data-mp="cvyo6sr1b8wo">The objective:</strong> {volume.objective}
          </p>
        </div>

        <p className="mt-4 text-sm italic leading-relaxed text-muted" data-id="element-282" data-mp="cu5k9l7t32sd">{volume.note}</p>
      </div>
    </article>;
}